import React from "react";
import { Row, Col, Typography } from "antd";
import dayjs from "dayjs";

const { Title, Text } = Typography;

const InvoiceSummary = ({ invoices }) => {
    const today = dayjs();

    const formatCurrency = (value) =>
        new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(value);

    const totalOverdue = invoices
        .filter((inv) => dayjs(inv.due_date).isBefore(today))
        .reduce((sum, inv) => sum + parseFloat(inv.total_amount || 0), 0);

    const dueNext7Days = invoices
        .filter((inv) => dayjs(inv.due_date).isAfter(today) && dayjs(inv.due_date).isBefore(today.add(7, "day")))
        .reduce((sum, inv) => sum + parseFloat(inv.total_amount || 0), 0);

    const totalOpen = invoices.reduce((sum, inv) => sum + parseFloat(inv.total_amount || 0), 0);

    return (
        <Row gutter={[16, 16]} justify="space-between" style={{ marginBottom: "20px", textAlign: "center" }}>
            <Col span={8}>
                <Title level={2} style={{ color: "red", marginBottom: "4px" }}>{formatCurrency(totalOverdue)}</Title>
                <Text style={{ fontSize: "14px", color: "#666" }}>Überfällige Rechnungen</Text>
            </Col>
            <Col span={8}>
                <Title level={2} style={{ color: "orange", marginBottom: "4px" }}>{formatCurrency(dueNext7Days)}</Title>
                <Text style={{ fontSize: "14px", color: "#666" }}>Fällig in 7 Tagen</Text>
            </Col>
            <Col span={8}>
                <Title level={2} style={{ color: "black", marginBottom: "4px" }}>{formatCurrency(totalOpen)}</Title>
                <Text style={{ fontSize: "14px", color: "#666" }}>Offener Gesamtbetrag</Text>
            </Col>
        </Row>
    );
};

export default InvoiceSummary;